/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-sparse-arrays */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Grid } from "@mantine/core";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import {
  BsArrowRight,
  BsFacebook,
  BsGithub,
  BsStackOverflow,
  BsTwitter
} from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { SiGooglemessages } from "react-icons/si";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../images/logo1.png";
import { addMessage } from "../../redux/actions/frontendActions/messageAction";
function Footer() {
  const dispatch =useDispatch()
  const { myInfo } = useSelector((state) => state.Auth);
  const {  loader ,messageSuccessMessage, messageErrorMessage } = useSelector((state) => state.Message);

  const [Authstate, setAuthState] = useState({
    status:myInfo.status,
    image:myInfo.image,
    firstName:myInfo.firstName,
    lastName: myInfo.lastName,
    email: myInfo.email,
    phone: myInfo.phone,
    message: "",

  });

  const handleInput = (e) => {
    setAuthState({
      ...Authstate,
      [e.target.name]: e.target.value,
    });
  };
  const handleMessageSubmit = (e) => {
    e.preventDefault();
    dispatch(addMessage(Authstate))
  };
  useEffect(()=>{
    if(messageSuccessMessage){

      toast.success(messageSuccessMessage)
     window.location.reload();
    }
  }, [messageSuccessMessage, messageErrorMessage ]);


  return (
    <div className="footer-contact-wrapper">
      <Toaster position={'bottom-center'}
                reverseOrder={false}
                toastOptions={
                    {
                        style: {
                            fontSize: '15px'
                        }
                    }
                }
            />
      <div className="footer-contact-area  padding_container">
        <Grid columns={12}>
          <Grid.Col md={12} lg={4} className="text-area">
            <h2>Contact Us</h2>
            <p>
              Design, Development or Operations. Let's make it happen. Send me
              your no-obligation inquiry.
            </p>
          </Grid.Col>
          <Grid.Col md={12} lg={8}>
            <form onSubmit={handleMessageSubmit}>
              <div className="contact-form-area-grid">
                <div className="data">
                  <div className="name-flex">
                    <input
                      value={myInfo.firstName}
                      onChange={handleInput}
                      required
                      type="text"
                      placeholder="First Name*"
                      name="firstName"
                    />
                    <input
                      value={myInfo.lastName}
                      onChange={handleInput}
                      required
                      type="text"
                      placeholder="Last Name*"
                      name="lastName"
                    />
                  </div>
                  <div className="email">
                    
                    <input
                     value={myInfo.email} 
                      onChange={handleInput}
                      required
                      type="email"
                      name="email"
                      placeholder="Email*"
                    />
                  </div>
                  <div  className="number">
                    
                    <input
                    value={myInfo.phone}
                      onChange={handleInput}
                      required
                      type="number"
                      name="phone"
                      placeholder="Phone*"
                    />
                  </div>
                </div>
                <div>
                  <textarea
                   className="message"
                    onChange={handleInput}
                    required
                    name="message"
                    placeholder="Message*"
                  ></textarea>
                </div>
              </div>

              <div className="button-area">
                <button type="submit">
                 {loader ? "Please Wait!": " Send Message"} <BsArrowRight />
                </button>
              </div>
            </form>
          </Grid.Col>
        </Grid>
      </div>

      <div className="footer-items-section padding_container ">
        <div className="footer-items">
          <div className="item logo-item">
            <div className="logo">
              <img style={{width: "96px", height: "50px"}} src={logo} alt="" />
            </div>
            <div className="logo-text">
              Here, I provided my social media links. Before going to a argument
              you firstly contact me.
            </div>
            <div className="logo-svg">
              <a target="_blank" rel="noreferrer" href="https://www.facebook.com/iasraful1971">
                <BsFacebook />
              </a>
              <a  target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/as-dev">
                <FaLinkedin />
              </a>
              <a href="https://twitter.com/asl_dev"  target="_blank" rel="noreferrer">
                <BsTwitter />
              </a>
              <a   target="_blank" rel="noreferrer" href="https://github.com/iasraful1971">
                <BsGithub />
              </a>
              <a  target="_blank" rel="noreferrer" href="https://stackoverflow.com/users/16839821/asraful">
                <BsStackOverflow />
              </a>
            </div>
            <a href="mailto:iasraful107@gmail.com" className="message-btn">
              <button>
                <SiGooglemessages size={20} /> Contact Me
              </button>
            </a>
          </div>

          <div className="item">
            <h3>Useful Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about-me">About Me</Link>
              </li>
              <li>
                <Link to="/portfolio">Portfolio</Link>
              </li>
              <li>
                <Link to="/blogs">Articles</Link>
              </li>
              <li>
                <Link to="/service">Services</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
            </ul>
          </div>

          <div className="item">
            <h3>Terms & conditions</h3>
            <ul>
             <li>
                <Link to="/register">Account</Link>
              </li>
              <li>
                <Link to="/policy">Privacy & policy</Link>
              </li>
              <li>
                <Link to="/contact">Contact Me</Link>
              </li>
              <li>
                <Link to="/policy">Refund Policy</Link>
              </li>
            </ul>
          </div>
          <div className="item">
            <h3>Address</h3>
            <ul>
              <li>
                <p>
                  <a href="#">Gazipur, Dhaka, Bangladesh</a>
                </p>
              </li>
              <li>
                <p>
                  <a href="tel:+8801758015756">+8801758015756</a>
                </p>
              </li>
              <li>
                <p>
                  <a href="mailto:iasraful107@gmail.com">
                    iasraful107@gmail.com
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="copyright padding_container">
        <hr />
        <br />
        <span>
          Designed & Developed by
          <span className="green"> Muhammad Asraful</span>
        </span>
      </div>
    </div>
  );
}

export default Footer;
